export default __webpack_public_path__ + "static/media/NW0120.34I-35464_-20500_0.a0f8d1a6.jpg";